$(document).foundation();

(function ($) {
  // notification bar per page check if cookie is not set
  if ($(".notification-bar").length > 0) {
    // show notificaiton bar if cookie does not exist
    //var notificationId = $('.notification-bar').data('notification-id')
    //var notificationCookieName = 'notification-cookie-id-' + notificationId
    if (!Cookies.get("notification-bar-closed")) {
      $(".notification-bar").addClass("notification-bar--is-showing");
      $("body").addClass("has-notification-bar");
    }
    // close and set cookie
    $(".notification-bar .close-notification").on("click", function () {
      Cookies.set("notification-bar-closed", "1", { path: "", expires: 2 });
      $(".notification-bar").removeClass("notification-bar--is-showing");
      $("body").removeClass("has-notification-bar");
    });
  }

  // page recognition years
  $(".page-template-page-recognition .more").on("click", function (e) {
    e.preventDefault();
    $(".years .grid-x.hide").slice(0, 2).removeClass("hide");
    if ($(".years .grid-x.hide").length == 0) {
      $(this).remove();
    }
  });

  // more load
  $(
    ".page-template-page-news .more, .page-template-page-writing-lectures .more"
  ).on("click", function (e) {
    e.preventDefault();
    $(".more-boxes .cell.hide").slice(0, 9).removeClass("hide");
    if ($(".more-boxes .cell.hide").length == 0) {
      $(this).remove();
    }
  });

  // more load
  $(" .page-template-page-artist-program .more").on("click", function (e) {
    e.preventDefault();
    $(".more-boxes .cell.hide").slice(0, 4).removeClass("hide");
    if ($(".more-boxes .cell.hide").length == 0) {
      $(this).remove();
    }
  });

  // fade effect on scroll hero
  if ($(".title-parallax-work").length >= 1) {
    var $titleParallaxWork = $(".title-parallax-work");
    $(window).on("scroll", function () {
      var opacity = 1;
      if (Foundation.MediaQuery.is("medium up")) {
        var heightRatio = 3.25;
        if ($(".page-template-page-work, .single-theme_page")) {
          heightRatio = 2.75;
        }
        var parallaxTop =
          $("main").offset().top - $(window).height() / heightRatio;
        var scrollTop = $(window).scrollTop();
        var delta = parallaxTop - scrollTop;
        var opacity = delta / parallaxTop;
        //opacity -= 0.3
        if (scrollTop < 100) {
          opacity = 1;
        }
      }
      $titleParallaxWork.css({
        opacity: opacity,
      });
    });
  }

  // term slug scroll
  if ($("body").hasClass("term-slug-selected")) {
    var workNavOffset = $(".work-nav").offset().top;
    workNavOffset = workNavOffset - $("header").height();
    if (Foundation.MediaQuery.is("medium up")) {
      workNavOffset -= 50;
    } else {
      workNavOffset += 40;
    }
    $("html, body").animate({ scrollTop: workNavOffset }, 0);
  }

  // mobile toggle
  $(".mobile-toggle").on("click", function () {
    $("body").toggleClass("mobile-menu--is-open");
  });

  // search
  $("header .search-nav form .icomoon").on("click", function () {
    doSearch();
  });

  // search
  $("header .search-nav form").on("submit", function (e) {
    doSearch();
    e.preventDefault();
  });

  // search ajax
  function doSearch() {
    var keyword = $('header .search-nav input[type="text"]').val();
    if (keyword == "") {
      alert("Enter a keyword");
    } else {
      var url = "/?s=" + keyword;
      $.ajax({
        url: url,
        cache: false,
        dataType: "html",
      })
        .done(function (html) {
          var searchResultsHtml = $(html)
            .filter(".page")
            .find(".search-results")
            .html();
          $(".search-results-payload").html(searchResultsHtml);
        })
        .fail(function (error) {
          alert("Error loading " + url);
        });
    }
  }

  // search toggle
  $('a[href="#search"]').on("click", function (e) {
    $("body").toggleClass("search--is-showing");
    if ($("body").hasClass("search--is-showing")) {
      $('header .search-nav input[type="text"]').focus().select();
    }
    e.preventDefault();
  });

  // escape clicked close search
  $(document).on("keyup", function (e) {
    if (e.key == "Escape") {
      $("body").removeClass("search--is-showing");
    }
  });

  // search section scroll
  $(document).on("click", "[data-section-scroll]", function () {
    var section = $(this).data("section-scroll");
    var $target = $(
      '.search-boxes .more-boxes[data-section="' + section + '"]'
    );
    var targetOffsetTop = $target.offset().top;
    if (Foundation.MediaQuery.is("medium up")) {
      targetOffsetTop -= 120;
      $(".search-nav").animate({ scrollTop: targetOffsetTop }, 500);
    } else {
      targetOffsetTop -= 40;
      $("html, body").animate({ scrollTop: targetOffsetTop }, 500);
    }
  });

  // intro show more
  $(".intro .read-more").on("click", function () {
    $(this).remove();
    $(".intro .more").removeClass("hide");
  });

  // context & drawings carousel
  var carouselContextDrawings = {
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    wrapAround: true,
    ready: function () {
      toggleContextDrawingsArrows();
    },
  };

  var $carouselContextDrawings = $(".carousel-context-drawings").flickity(
    carouselContextDrawings
  );

  $(".context-drawings .icon-angle-left").on("click", function () {
    $carouselContextDrawings.flickity("previous");
  });

  $(".context-drawings .icon-angle-right").on("click", function () {
    $carouselContextDrawings.flickity("next");
  });

  // context & drawings lightbox
  $carouselContextDrawings.on(
    "staticClick.flickity",
    function (event, pointer, cellElement, cellIndex) {
      $("#reveal-context-drawings").foundation("open");
      $carouselLarge.flickity("select", cellIndex).flickity("resize");
      if (Foundation.MediaQuery.current == "small") {
        $("#reveal-context-drawings").css("top", "");
      }
    }
  );

  $("#reveal-context-drawings .icon-close").on("click", function () {
    $("#reveal-context-drawings").foundation("close");
  });

  // Single Project text image carousel
  var textImageCarousel = {
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    wrapAround: false,
    on: {
      ready: function () {
        // Attach arrow event
        var _carousel = this;
        var $wrapper = _carousel.$element.closest(".text-image-carousel-block");
        var $prev = $wrapper.find(".text-image-carousel-arrow--prev");
        var $next = $wrapper.find(".text-image-carousel-arrow--next");
        var $firstImage = $(_carousel.selectedElement).find(
          ".text-image-carousel-item__image"
        );
        var firstImageHeight = $firstImage.innerHeight();

        $next.on("click", function () {
          _carousel.next();
        });

        $prev.on("click", function () {
          _carousel.previous();
        });

        // Grey out the prev arrow
        $prev.addClass("disabled");

        // Set height of arrow equal to image
        $prev.add($next).height(firstImageHeight);
      },
      change: function (i) {
        var index = i + 1;
        var _carousel = this;
        var $wrapper = _carousel.$element.closest(".text-image-carousel-block");
        var totalSlides = _carousel.slides.length;
        var $prev = $wrapper.find(".text-image-carousel-arrow--prev");
        var $next = $wrapper.find(".text-image-carousel-arrow--next");
        // var $firstImage = $(_carousel.selectedElement).find(
        //   ".text-image-carousel-item__image"
        // );
        // var firstImageHeight = $firstImage.innerHeight();

        $wrapper.find(".text-image-carousel-arrow").removeClass("disabled");

        if (index == 1) {
          $prev.addClass("disabled");
        }

        if (index == totalSlides) {
          $next.addClass("disabled");
        }

        // Set height of arrow equal to image
        // $prev.add($next).height(firstImageHeight);
      },
      resize: function () {
        var _carousel = this;
        var $wrapper = _carousel.$element.closest(".text-image-carousel-block");
        var $arrows = $wrapper.find(".text-image-carousel-arrow");
        var $firstImage = $(_carousel.selectedElement).find(
          ".text-image-carousel-item__image"
        );
        var firstImageHeight = $firstImage.innerHeight();

        $arrows.height(firstImageHeight);
      },
    },
  };

  var $textImageCarousel = $(".text-image-carousel").flickity(
    textImageCarousel
  );

  //$('#reveal-context-drawings').foundation('open')

  var $carouselLarge = $(".carousel-large").flickity({
    cellSelector: ".carousel-cell",
    setGallerySize: false,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    wrapAround: true,
    on: {
      change: function (index) {
        // pause videos
        pauseAllVideos();
        // change counter
        var nextIndex = index + 1;
        var indexText = nextIndex;
        $(".current").html(indexText);
      },
    },
  });

  $("#reveal-context-drawings .icon-angle-left").on("click", function () {
    $carouselLarge.flickity("previous");
  });

  $("#reveal-context-drawings .icon-angle-right").on("click", function () {
    $carouselLarge.flickity("next");
  });

  // https://github.com/metafizzy/flickity/issues/740
  $carouselLarge.on("dragStart.flickity", function (event, pointer) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });

  $carouselLarge.on("dragEnd.flickity", function (event, pointer) {
    document.ontouchmove = function (e) {
      return true;
    };
  });

  // pause all vimeo videos
  $("[data-reveal]").on("closed.zf.reveal", function () {
    pauseAllVideos();
  });

  // show body after load
  setTimeout(function () {
    $("body").addClass("is-visible");
  }, 200);

  // hide and show context arrows
  function toggleContextDrawingsArrows() {
    $(".carousel-context-drawings")
      .imagesLoaded()
      .done(function (instance) {
        var totalWidth = 0;
        $(".carousel-context-drawings img").each(function () {
          totalWidth += $(this).width() + 24;
        });
        totalWidth -= 24;
        if (totalWidth < $(".carousel-context-drawings").width()) {
          $(".context-drawings .cell-arrows").addClass("hide");
        } else {
          $(".context-drawings .cell-arrows").removeClass("hide");
        }
      })
      .progress(function (instance, image) {
        //var result = image.isLoaded ? 'loaded' : 'broken'
        //console.log( 'image is ' + result + ' for ' + image.img.src )
      });
  }

  // helper function to pause videos
  function pauseAllVideos() {
    $(".carousel-cell-video").each(function () {
      var iframe = $(this).find("iframe").get(0);
      var player = new Vimeo.Player(iframe);
      player.pause();
    });
  }

  // People Tabs
  $('.sets-filter').on('click', 'a', function(e) {
    e.preventDefault();
    var $link = $(this),
        target = $link.attr('href'),
        $target = $(target);

    if ($target.length > 0) {
      $link.parent().addClass('active').siblings().removeClass('active')
      $target.fadeTo(250, 1).siblings('.set-panel').hide();
    }
  });

  // Countdown
  $('.js-countdown-timer').each(function() {
    var $el = $(this),
        date = $el.data('countdown')
    
    $el.countdown(date, function(event) {
      $el.find('.js-countdown-timer__days .js-countdown-timer__part__value').html(event.strftime('%-D'))
      $el.find('.js-countdown-timer__hours .js-countdown-timer__part__value').html(event.strftime('%-H'))
      $el.find('.js-countdown-timer__minutes .js-countdown-timer__part__value').html(event.strftime('%-M'))
      $el.find('.js-countdown-timer__seconds .js-countdown-timer__part__value').html(event.strftime('%-S'))
    })
  });

  // debugger
  $(window)
    .on("resize", function () {
      toggleContextDrawingsArrows();
    })
    .trigger("resize");

  $(".debugger").on("click", function (e) {
    $(this).remove();
  });

  $(".focuspoint").focusPoint();
})(jQuery);
